import '../styles/footer.css'
import { NavLink } from 'react-router-dom';
import logo from '../imgs/logo_1.png'

export default function Downpage() {
    return (
        <footer className="footer">
            <div className="footer__inner">
                <div className="footer__brand">
                    <img src={logo} alt="EosRmg logo" className="footer__logo" />
                    <div>
                        <span className="footer__name">EosRmg</span>
                        <span className="footer__tagline">Android App Studio</span>
                    </div>
                </div>

                <nav className="footer__links">
                    <NavLink to="/">Home</NavLink>
                    <NavLink to="/apps">Apps</NavLink>
                    <NavLink to="/contact">Contact</NavLink>
                    <NavLink to="/privacypolicy">Privacy</NavLink>
                </nav>

            </div>

            <div className="footer__bottom">
                <span>&copy; {new Date().getFullYear()} EosRmg. All rights reserved.</span>
            </div>
        </footer>
    );
}
